<template>
    <h2 class="font-bold text-lg text-gray-800">{{ text }}</h2>
</template>

<script>
    export default {
        props: {
            text: {
                required: true,
                type: String,
            },
        },
    }
</script>
